<template>
    <body>
    <form>
        <div class="container_form">
            <h2>My best Friend </h2>
            <span style="font-size: 12px;color: #ffa07a">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                Please complete all fields to validate form
            </span>
            <br>
            <br>
            <label for="petname"><b>Name</b></label>
            <input type="text" placeholder="Pet name..." id="petname"  v-model="this.pet_profile.name" required>

            <label for="breed"><b>The breed of</b></label>
            <input type="text" placeholder="The bread of..." id="breed" v-model="this.pet_profile.breed" required>

            <label for="daten"><b>Birthday(choose an approximate date)</b></label>
            <input type="date" placeholder="The bread of..." id="daten" v-model="this.pet_profile.daten" required>

            <label for="phistory"><b>History (Adopted, Found, Received, Bought..)</b></label>
            <input type="text" placeholder="Few words about..." id="phistory" v-model="this.pet_profile.phistory" required>

            <label><b>Sex</b>
            </label>
            <br>
            <input type="radio"  v-model="this.pet_profile.sex" value="male" required>
            <label>Male</label>
            <input type="radio"  v-model="this.pet_profile.sex" value="female" required>
            <label>Female</label>
            <br><br>
            <label for="petpound"><b> Pound [ kg ] </b></label>
            <input type="number" min="0" id="petpound"  v-model="this.pet_profile.pound" required>

            <br>
            <label for="pmedical"><b>Medical treatment </b></label>
            <input type="text" placeholder="Few words about it..." id="pmedical" v-model="this.pet_profile.medical" required>

            <br><br>
            <label><b>Sterilizer</b>
            </label><br>
            <input type="radio"  v-model="this.pet_profile.sterilizer" value="yes" required>
            <label>yes</label>
            <input type="radio"  v-model="this.pet_profile.sterilizer" value="no" required>
            <label>no</label>
            <br><br>
            <label for="pbeheviour"><b>What Behavior has with other animals? </b></label>
            <input type="text" placeholder="Few words about it..." id="pbeheviour" v-model="this.pet_profile.behaviour" required>

            <label for="pwalks"><b>How many walks does he usually take per day? </b></label>
            <input type="number" min="0"  id="pwalks" v-model="this.pet_profile.walks" required>

            <label for="photel"><b>Has he been accommodated so far? </b></label>
            <input type="text" placeholder="Never, yes at .. , yes with friends..." id="photel" v-model="this.pet_profile.hotel" required>

            <label for="pmeals"><b>How many meals does he have per day? </b></label>
            <input type="number" min="0" id="pmeals" v-model="this.pet_profile.meals" required>

            <label for="pfoodq"><b>How much food does he get per day? ( in grams ) </b></label>
            <input type="number" min="0"  id="pfoodq" v-model="this.pet_profile.foodq" required>

            <label for="porder"><b>What is the order? Does he eat and then walk or vice versa? </b></label>
            <input type="text" placeholder="Eat, walk order..." id="porder" v-model="this.pet_profile.order" required>

            <label for="pfed"><b>How is your dog fed? Wet, Dry, Mixed, Cooked, otherwise</b></label>
            <input type="text" placeholder="Wet, dry, mixed..." id="pfed" v-model="this.pet_profile.fedtype" required>

            <label for="penergy"><b>On a scale of 1 to 10 how energetic is your pet? </b></label>
            <input type="number" min="0" max="10"  id="penergy" v-model="this.pet_profile.energy" required>

            <label for="paggresivity"><b>On a scale of 1 to 10, how aggressive is your pet?</b></label>
            <input type="number" min="0" max="10"  id="paggresivity" v-model="this.pet_profile.aggresivity" required>

            <label for="pscare"><b>Does it need special care?</b></label>
            <input type="text" placeholder="Please detail..." id="pscare" v-model="this.pet_profile.scare" required>

            <label for="panxios"><b>Is he anxious if he is left alone in the house?</b></label>
            <input type="text" placeholder="Please detail..." id="panxios" v-model="this.pet_profile.anxios" required>

            <label for="phuman"><b>Does the pet need to be constantly with a human presence?</b></label>
            <input type="text" placeholder="Please detail..." id="phuman" v-model="this.pet_profile.human" required>

            <label for="pdef"><b>Where he know  to defecate ? ( outside/inside/....)</b></label>
            <input type="text" placeholder="Please detail..." id="pdef" v-model="this.pet_profile.defecate" required>

            <label><b>He is not friendly and does not accept the company of other animals</b>
            </label><br>
            <input type="radio"  v-model="this.pet_profile.friendly" value="yes" required>
            <label>yes</label>
            <input type="radio"  v-model="this.pet_profile.friendly" value="no" required>
            <label>no</label>
            <br>
            <br>
            <label>
                <input type="checkbox" v-model="gdpr" name="remember">
                <span style="font-size: 12px">Confirm and accept that the input data will be saved in the App Database</span>
            </label>

            <button v-show="!isUpdate" :disabled="checkGDPR" type="button" @click.prevent="saveProfile">Save</button>
            <button v-show="isUpdate" :disabled="checkGDPR" type="button" @click.prevent="updateProfile">Update</button>
            <button class="cancelbtn" type="button" @click.prevent="cancelForm">Cancel</button>
        </div>
    </form>
    <br>
    <div style="font-size: 10px;text-align: center">
        <span style="color: yellow"><i class="fa fa-shield" aria-hidden="true"></i> Privacy Policy</span> <br>
        The input data <span style="font-weight: bold">are </span> stored on the App Server.
    </div>
    </body>
</template>
<script>
    import {getBaseURL} from '../url_endpoints.js'
    import {ulip_post,ulip_put} from '../https_requests.js'
    export default {
        name:'PetProfileForm',
        data() {
            return {
                baseURL:null,
                gdpr:null,
                update:false,
                selected_pet:null,
                pet_profile : {
                    name:'',
                    breed:'',
                    daten: null,
                    sex:'',
                    phistory:'',
                    sterilizer:'',
                    pound:0,
                    medical:'',
                    beheviour:'',
                    walks:0,
                    hotel:'',
                    meals:0,
                    foodq:0,
                    order:'',
                    fedtype:'',
                    energy:0,
                    aggresivity:0,
                    scare:'',
                    anxios:'',
                    human:'',
                    defecate:'',
                    friendly:'',
                }
            }
        },
        computed: {
          checkGDPR() {
              let petNameExist = false
              //console.log(this.gdpr)
              // check pet name only when add new pet form , not on update
              if(!this.selected_pet) {
                  petNameExist = this.checkPetNameExist(this.pet_profile.name)
                  if(petNameExist) {
                      alert('Pet Name in DataBase!\nPlease change it or complete name...')
                  }
              }
              return !this.gdpr || this.pet_profile.name.length ===0 || petNameExist ? true : !this.gdpr
          },
            isUpdate() {
              return this.update
            }
        },
        mounted() {
            this.baseURL = getBaseURL()
            this.selected_pet= this.$store.getters.getPetId
            if(!this.selected_pet) {
                // create new one
            }else {
                //console.log('update pet form ' + selected_pet)
                // get pet form data
                fetch(this.baseURL+'/pets?id='+this.selected_pet,{
                    methods: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then( rsp => {
                    return rsp.json()
                }).then( data => {
                    if(data.length > 0 ) {
                        //found pet form
                        let pf = data[0].info.split('#')
                        // set object info
                        let pet ={
                            name:pf[0],
                            breed:pf[1],
                            daten:pf[2],
                            sex:pf[3],
                            phistory:pf[4],
                            sterilizer:pf[5],
                            pound:pf[6],
                            medical:pf[7],
                            beheviour:pf[8],
                            walks:pf[9],
                            hotel:pf[10],
                            meals:pf[11],
                            foodq:pf[12],
                            order:pf[13],
                            fedtype:pf[14],
                            energy:pf[15],
                            aggresivity:pf[16],
                            scare:pf[17],
                            anxios:pf[18],
                            human:pf[19],
                            defecate:pf[20],
                            friendly:pf[21],
                        }
                        this.pet_profile = pet
                        this.update = true
                    }
                })
            }
        },
        methods: {
            computeInfoPet() {
                const infos = Object.values(this.pet_profile)
                return infos.join('#')
            },
            updateProfile(){
                let petObj = {
                    officeid: this.$store.getters.getAppointOfficeId,
                    info:this.computeInfoPet()
                }
                if(!petObj.officeid){
                    alert('Sorry , Internal App Error!')
                    this.$router.push('/new_appointment')
                    window.scrollTo(0,0)
                } else {
                    ulip_put(this.baseURL,'/pets',this.selected_pet,petObj).then( () => {
                        alert('Pet Info updated ! \n Thank You...')
                        this.$router.push('/new_appointment')
                        window.scrollTo(0,0)
                    }).catch(err => {
                        alert(err.message+'\nBackend Server is not running!\n Try again later...')
                    })
                }
            },
            saveProfile() {
                let petObj = {
                    officeid: this.$store.getters.getAppointOfficeId,
                    info:this.computeInfoPet()
                }
                if(!petObj.officeid){
                    alert('Sorry , Internal App Error!')
                    this.$router.push('/new_appointment')
                    window.scrollTo(0,0)
                } else {
                    ulip_post(this.baseURL,'/pets',petObj).then( (rsp) => {
                        alert('Pet Info saved ! \n Thank You...')
                        // store local data form
                        const lpf = localStorage.getItem('petforms')
                        if(!lpf) {
                            // nothing saved before on local store
                            localStorage.setItem('petforms',JSON.stringify([{id:rsp.id,name:this.pet_profile.name}]))
                        }else {
                            // add new pet form
                            const formarray = JSON.parse(lpf)
                            formarray.push({id:rsp.id , name:this.pet_profile.name})
                            localStorage.setItem('petforms',JSON.stringify(formarray))
                        }
                        this.$router.push('/new_appointment')
                        window.scrollTo(0,0)
                    }).catch(err => {
                        alert(err.message+'\nBackend Server is not running!\n Try again later...')
                    })
                }
            },
            cancelForm() {
                this.$router.push('/new_appointment')
                window.scrollTo(0,0)
            },
            checkPetNameExist(petname) {
                const lpf = localStorage.getItem('petforms')
                if(!lpf){
                    return false
                }else {
                    const petlist =JSON.parse(lpf)
                    for(let pet of petlist){
                        if(pet.name === petname){
                            return true
                        }
                    }
                    return false
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    body {
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        background-color: black;
        color: white;
        height:350vh;
    }
    .container_form {
        padding: 16px 30%;
    }
    input[type=text], input[type=datetime-local],input[type=date] {
        width: 100%;
        padding: 10px 20px;
        margin: 5px 0;
        display: inline-block;
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    input[type=number] {
        width: 7em;
        padding: 10px 20px;
        margin_left: 50px;
        display: block;
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    button {
        background-color: dodgerblue;
        color: white;
        padding: 14px 20px;
        margin: 8px 0;
        border: none;
        cursor: pointer;
        width: 100%;
        opacity: 0.8;
    }
    button:hover {
        opacity: 1.0;
    }
    button:disabled {
        background-color: darkgray;
    }
    .cancelbtn {
        background-color: crimson;
    }
    @media screen and (max-width: 600px) {
        label {
            font-size: 12px;
        }
        .container_form {
            padding: 16px 15%;
        }
    }

</style>